import { FormEventHandler, useState } from "react";
import styles from "./styles.module.scss";
import TemplateItem from "./Template";
import { Spin } from "antd";
import { Template } from "../../types";

interface SelectTemplateWidgetsProps {
  loading: boolean;
  templates: Template[];
  onGenerateImage: (prompt: string[]) => void;
  setCustomPrompt: (prompt: string) => void;
  setSelectedPrompt: (prompt: string) => void;
}

const SelectTemplateWidgets = ({
  loading,
  templates,
  onGenerateImage,
  setCustomPrompt,
  setSelectedPrompt,
}: SelectTemplateWidgetsProps) => {
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const handleTemplateSelect = (prompt: string) => {
    setSelectedPrompt(prompt);
    setCustomPrompt(prompt);
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    const inputs = form.querySelectorAll<HTMLInputElement>("input:checked");

    const checkedTemplates = Array.from(inputs).map((el) => el.value);
    if (checkedTemplates.length === 0) return;

    onGenerateImage(checkedTemplates);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.block}>
      {loading ? (
        <div className={styles.block__loading}>
          <Spin size="large" />
        </div>
      ) : (
        <div className={styles.accordion}>
          {templates.map((template, i) => (
            <TemplateItem
              key={template.name}
              index={i}
              template={template}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
              onSelect={handleTemplateSelect}
            />
          ))}
        </div>
      )}
    </form>
  );
};

export default SelectTemplateWidgets;
